// extracted by mini-css-extract-plugin
module.exports = {"fileNm":"BoardFileView_fileNm__1vZUG"};